module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN205_347206647.c821e61e.png";